import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  en: {
    "nav.home": "Home", "nav.find_jobs": "Find Jobs", "nav.bookings": "Bookings", "nav.messages": "Messages",
    "nav.profile": "Profile", "nav.dashboard": "Dashboard", "nav.jobs": "Jobs", "nav.support": "Support",
    "nav.alerts": "Alerts", "nav.availability": "Availability", "nav.documents": "Documents",
    "nav.payouts": "Payouts", "nav.referrals": "Referrals", "nav.skill_tests": "Skill Tests",
    "nav.team": "Team", "nav.invoices": "Invoices", "nav.live_ops": "Live Ops",
    "hero.title_1": "Flexible staff.",
    "hero.title_2": "Reliable businesses.",
    "hero.title_3": "Simple booking.",
    "hero.sub": "Connect businesses with qualified supply staff who are available exactly when you need them.",
    "cta.find_work": "Find Work", "cta.find_staff": "Find Staff",
    "btn.book_shift": "Book this shift", "btn.cancel": "Cancel", "btn.save": "Save changes",
    "btn.confirm": "Yes, book shift", "btn.log_in": "Log in", "btn.log_out": "Log out",
    "btn.get_started": "Get started",
    "welcome.back": "Welcome back", "lang.label": "Language",
  },
  pl: {
    "nav.home": "Start", "nav.find_jobs": "Znajdź pracę", "nav.bookings": "Rezerwacje", "nav.messages": "Wiadomości",
    "nav.profile": "Profil", "nav.dashboard": "Panel", "nav.jobs": "Oferty", "nav.support": "Pomoc",
    "nav.alerts": "Powiadomienia", "nav.availability": "Dostępność", "nav.documents": "Dokumenty",
    "nav.payouts": "Wypłaty", "nav.referrals": "Polecenia", "nav.skill_tests": "Testy umiejętności",
    "nav.team": "Zespół", "nav.invoices": "Faktury", "nav.live_ops": "Na żywo",
    "hero.title_1": "Elastyczny personel.",
    "hero.title_2": "Zaufane firmy.",
    "hero.title_3": "Prosta rezerwacja.",
    "hero.sub": "Łączymy firmy z wykwalifikowanym personelem tymczasowym dostępnym dokładnie wtedy, gdy go potrzebujesz.",
    "cta.find_work": "Znajdź pracę", "cta.find_staff": "Znajdź personel",
    "btn.book_shift": "Zarezerwuj zmianę", "btn.cancel": "Anuluj", "btn.save": "Zapisz zmiany",
    "btn.confirm": "Tak, rezerwuję", "btn.log_in": "Zaloguj się", "btn.log_out": "Wyloguj",
    "btn.get_started": "Zacznij",
    "welcome.back": "Witaj ponownie", "lang.label": "Język",
  },
  ur: {
    "nav.home": "ہوم", "nav.find_jobs": "نوکریاں", "nav.bookings": "بکنگز", "nav.messages": "پیغامات",
    "nav.profile": "پروفائل", "nav.dashboard": "ڈیش بورڈ", "nav.jobs": "نوکریاں", "nav.support": "مدد",
    "nav.alerts": "اطلاعات", "nav.availability": "دستیابی", "nav.documents": "دستاویزات",
    "nav.payouts": "ادائیگیاں", "nav.referrals": "ریفرلز", "nav.skill_tests": "ہنر ٹیسٹ",
    "nav.team": "ٹیم", "nav.invoices": "چالان", "nav.live_ops": "لائیو",
    "hero.title_1": "لچکدار عملہ۔",
    "hero.title_2": "قابلِ اعتماد کاروبار۔",
    "hero.title_3": "آسان بکنگ۔",
    "hero.sub": "کاروبار کو اہل سپلائی عملے سے جوڑیں جو آپ کی ضرورت کے وقت دستیاب ہو۔",
    "cta.find_work": "کام تلاش کریں", "cta.find_staff": "عملہ تلاش کریں",
    "btn.book_shift": "شفٹ بک کریں", "btn.cancel": "منسوخ کریں", "btn.save": "محفوظ کریں",
    "btn.confirm": "ہاں، بک کریں", "btn.log_in": "لاگ اِن", "btn.log_out": "لاگ آؤٹ",
    "btn.get_started": "شروع کریں",
    "welcome.back": "خوش آمدید", "lang.label": "زبان",
  },
  ro: {
    "nav.home": "Acasă", "nav.find_jobs": "Locuri de muncă", "nav.bookings": "Rezervări", "nav.messages": "Mesaje",
    "nav.profile": "Profil", "nav.dashboard": "Panou", "nav.jobs": "Joburi", "nav.support": "Suport",
    "nav.alerts": "Alerte", "nav.availability": "Disponibilitate", "nav.documents": "Documente",
    "nav.payouts": "Plăți", "nav.referrals": "Recomandări", "nav.skill_tests": "Teste de abilități",
    "nav.team": "Echipă", "nav.invoices": "Facturi", "nav.live_ops": "Live",
    "hero.title_1": "Personal flexibil.",
    "hero.title_2": "Companii de încredere.",
    "hero.title_3": "Rezervare simplă.",
    "hero.sub": "Conectăm companiile cu personal de rezervă calificat, disponibil exact când aveți nevoie.",
    "cta.find_work": "Găsește de muncă", "cta.find_staff": "Găsește personal",
    "btn.book_shift": "Rezervă tura", "btn.cancel": "Anulează", "btn.save": "Salvează",
    "btn.confirm": "Da, rezervă", "btn.log_in": "Autentificare", "btn.log_out": "Deconectare",
    "btn.get_started": "Începe",
    "welcome.back": "Bine ai revenit", "lang.label": "Limbă",
  },
};

export const LANGS = [
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
  { code: "ur", label: "اردو" },
  { code: "ro", label: "Română" },
];

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("shiftflex.lang") || "en");
  useEffect(() => {
    localStorage.setItem("shiftflex.lang", lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", lang === "ur" ? "rtl" : "ltr");
  }, [lang]);
  const t = (key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
